var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "-0.45 -0.45 15 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.929 5.224V1.625c0-.386.31-.696.696-.696h3.6a.35.35 0 0 1 .348.348v1.161a.35.35 0 0 1-.349.348H2.786v2.438a.35.35 0 0 1-.348.349h-1.16a.35.35 0 0 1-.35-.349zm8.359-3.947v1.161a.35.35 0 0 0 .348.348h2.438v2.438a.35.35 0 0 0 .349.349h1.16a.35.35 0 0 0 .349-.349V1.625a.695.695 0 0 0-.697-.696H9.636a.35.35 0 0 0-.348.348zm4.296 8.011h-1.161a.35.35 0 0 0-.349.348v2.438H9.636a.35.35 0 0 0-.348.349v1.16a.35.35 0 0 0 .348.349h3.6c.385 0 .696-.31.696-.697V9.636a.35.35 0 0 0-.348-.348zm-8.011 4.296v-1.161a.35.35 0 0 0-.349-.349H2.786V9.636a.35.35 0 0 0-.348-.348h-1.16a.35.35 0 0 0-.35.348v3.6c0 .385.311.696.697.696h3.6a.35.35 0 0 0 .348-.348z",
    id: "bic45v9fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.2634fd3d62db68ef629c03247ed14c66.svg";
export { ForwardRef as ReactComponent };